<section class="section section--inset" id="vm-error">
  <div class="gd__container">

    <div class='svgcontainter'>
      <div class='divpoppetje'>
        <div id='circle'>
          <svg id="poppetje" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128.15 193.62">
            <defs>
              <style>
                .cls-1 {
                  fill: #466077;
                }

                .cls-2 {
                  fill: #22303a;
                }

                .cls-3 {
                  fill: #ffe0b6;
                }

                .cls-4 {
                  opacity: 0.95;
                }

                .cls-5 {
                  fill: #ffcb8d;
                }

                .cls-6 {
                  fill: #aa8f66;
                }

                .cls-7,
                .cls-8 {
                  fill: #332100;
                }

                .cls-7 {
                  stroke: #ffe0b6;
                  stroke-miterlimit: 10;
                  stroke-width: 1.13px;
                }

                .cls-9 {
                  fill: #543800;
                }

                .cls-10 {
                  fill: #c18772;
                }
              </style>
            </defs>
            <title>Artboard 1</title>
            <g id="Layer_66" data-name="Layer 66">
              <path class="cls-1"
                d="M114.15,193.62h-100v-55a12,12,0,0,1,12-12c2.28,2.53,15,16.18,36,17,23.33.91,38-14.77,40-17a12.31,12.31,0,0,1,8.47,3.52,12.05,12.05,0,0,1,3.53,8.48Z" />
              <path class="cls-2"
                d="M102.15,126.62a10.64,10.64,0,0,1,3.47.14,24.1,24.1,0,0,1,11.53,5.86c5.64,5.21,7.94,13.82,9,18a65.92,65.92,0,0,1,2,16q0,13.5-.05,27H114.15v-55A12,12,0,0,0,102.15,126.62Z" />
              <path class="cls-2"
                d="M26,126.62a10.59,10.59,0,0,0-3.46.14A24.18,24.18,0,0,0,11,132.62c-5.64,5.21-7.94,13.82-9,18a65,65,0,0,0-2,16v27H14v-55a12,12,0,0,1,12-12Z" />
              <path class="cls-3" d="M12.15,31.62v51h0a50.5,50.5,0,0,0,101,0h0v-51Z" />
              <circle class="cls-3" cx="14.15" cy="85.62" r="11" />
              <g class="cls-4">
                <circle class="cls-5" cx="111.15" cy="85.62" r="11" />
              </g>
              <g class="cls-4">
                <path class="cls-5" d="M63.15,31.62v101h.49c27.18,0,49.23-22.34,49.5-50h0v-51Z" />
              </g>
              <path class="cls-6"
                d="M107.4,75.12a43.62,43.62,0,0,1-19.76,36.35,24.5,24.5,0,0,0-20.49-24v4.15a4,4,0,0,1-8,0V87.45a24.5,24.5,0,0,0-20.5,24.17v1.13A43.76,43.76,0,0,1,16.9,75.12c0-8.64,3.57-21.7,8-28.5l-12.75-2v38h0a50.5,50.5,0,0,0,101,0h0v-39l-13.75,3C103.83,53.42,107.4,66.48,107.4,75.12Z" />
              <ellipse class="cls-7" cx="43.15" cy="73.12" rx="4" ry="4.5" />
              <ellipse class="cls-8" cx="80.65" cy="72.62" rx="3.5" ry="4" />
              <path class="cls-3"
                d="M80.15,109.62c.48,4.93-8.56,11-17,11s-17.48-6.07-17-11,9.93-8,17-8S79.68,104.82,80.15,109.62Z" />
              <path class="cls-9"
                d="M111.15,31.62c2.73.63,4.61,9.6,2,43l-7,10c1.22-7.21,2.13-19.93-4-33-3-6.28-7.13-15.18-15-17-9.43-2.17-12.8,8.61-25,8-11-.55-15.57-9.42-25-7-4.27,1.09-6.94,3.83-9,6-13.41,14.1-10.7,39.4-10,45l-6-12a157.65,157.65,0,0,0,0-23c-.88-11.88-2.75-18.45,0-28a32.93,32.93,0,0,1,5-11c11.2-15,36-12.86,46-12,6.12.53,31.55,2.72,37,16,1.13,2.75,2.26,8.08,2.69,8s.26-2.58-.69-5c-1.62-4.09-5.12-5.84-5-6s8.48,2.72,10,9c.78,3.21-.88,6.24,1,8A5,5,0,0,0,111.15,31.62Z" />
              <path class="cls-10"
                d="M50.15,110.62a17.9,17.9,0,0,1,5.9-3,22.83,22.83,0,0,1,13.2,0,17.71,17.71,0,0,1,5.9,3c-2.22-.23-4.29-.54-6.36-.71s-4.1-.29-6.14-.29-4.08.09-6.14.29S52.36,110.38,50.15,110.62Z" />
            </g>
          </svg>
        </div>
      </div>
      <div class='divtraantje'>
        <svg id="traantje" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5.86">
          <defs>
            <style>
              .cls-100 {
                fill: #6bcef3;
              }
            </style>
          </defs>
          <title>Artboard 1</title>
          <g id="traan">
            <path class="cls-100" d="M4,3.86a2,2,0,1,1-4,0C0,2.59.8.56,2,0,3.2.56,4,2.59,4,3.86Z" />
          </g>
        </svg>
      </div>
      <div class='divtraantjetwee'>
        <svg id="traantjetwee" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5.86">
          <defs>
            <style>
              .cls-100 {
                fill: #6bcef3;
              }
            </style>
          </defs>
          <title>Artboard 1</title>
          <g id="traantwee">
            <path class="cls-100" d="M4,3.86a2,2,0,1,1-4,0C0,2.59.8.56,2,0,3.2.56,4,2.59,4,3.86Z" />
          </g>
        </svg>
      </div>
    </div>

    <h2 [innerHTML]="pageTitle"></h2>
    <div class='tekst' [innerHTML]="pageContent"></div>
  </div>
</section>